import axios from "axios";

const api = axios.create({
  baseURL: `${window.location.origin}/api`,
  withCredentials: true,
  timeout: 30000,
});

export default api;
